<template>
    <div class="custom">
      <template v-if="!isCustomExcel">
        <div class="excel-row" :style="{width: isScrollY ? `calc(100% - ${scrollStyle.width})` : ''}">
          <div class="scroll-row" ref="scrollRow">
            <div class="serialNumber" v-if="tableDetailData.reCheck" :style="[tableDetailData.titleConfig, { width: getXhWidth() }, getAlign(tableDetailData.titleConfig)]">
              序号
            </div>
            <div ref="excelRow" class="excel-row-item"></div>
            <div class="todo" v-if="isAppenTodo" :class="isScrollX && !isScrollXbuttom && tableDetailData.tableModel === 'scroll' ? 'scroll-todo' : ''" :style="{ width: todoWidth + 'px' }">
              <div :style="[tableDetailData.titleConfig, { textAlign: 'center' }]">操作</div>
            </div>
          </div>
        </div>
      </template>
      <div class="fixed-right-patch" v-if="isScrollY" :style="scrollStyle"></div>
    </div>
</template>

<script>
import { parseWidth, generateHTMLTableWithWidth, getScrollbarWidth, generateTableList } from '@/components/schoolInstrument/mixins/utils'
export default {
  // 组件名称
  name: 'customRow',
  // 组件状态值
  data () {
    return {
      isScrollY: true,
      isScrollX: false,
      isScrollXbuttom: false,
      scrollStyle: {},
      isCheckAll: false,
      scrollLeft: 0
    }
  },
  props: {
    todoWidth: {
      type: Number,
      default: 60
    },
    tableColRef: {
      type: Array,
      default: () => ([])
    },
    tableRef: {
      type: Object,
      default: ()=>({})
    },
    tableDetailData: {
      type: Object,
      default: ()=>({})
    },
    tablewidth: {
      type: Number,
      default: 0
    }
  },
  // 计算属性
  computed: {
    isAppenTodo () {
      return Boolean(this.tableDetailData.type === 'detailed' && this.tableDetailData.relevance && this.tableDetailData.relevance.length > 0 && (!this.tableDetailData.isRelevance || this.tableDetailData.isRelevance === 'open'))
    },
    isFixed () {
      return this.tableDetailData.tableModel === 'fixed'
    },
    isCustomExcel () {
      const config = this.tableDetailData.titleRowConfig
      const flag = Object.keys(config).length === 0
      return flag
    },
    tableWidth() {
      const el = document.getElementsByClassName('custom-table-title')[0]
      let w = 0
      if (el) {
        w = el.getBoundingClientRect().width
      }
      return w
    },
    colsTotalWidth () {
      const cols = this.tableColRef || []
      const widthList = []
      let total = 0
      for (const ele of cols) {
        const id = ele.columnId
        const col = document.getElementsByName(id)[0]
        if (col) {
          const width = col.getAttribute('width')
          total += +width
          widthList.push(total)
        }
      }
      return widthList
    }
  },
  mounted() {
    this.init()
  },
  // 组件方法
  methods: {
    init() {
      if (!this.isCustomExcel) {
        this.$nextTick(() => {
          const ref = this.tableRef
          const bodyWrapper = ref.bodyWrapper
          if (!ref.$el) return
          const bodyHeight = ref.$el.getBoundingClientRect().height
          const body = ref.bodyWrapper.querySelector('.el-table__body');
          const scrollY = body.offsetHeight > bodyHeight
          this.isScrollY = scrollY
          const scrollW = getScrollbarWidth()
          const style = {
            width: scrollW + 'px'
          }
          this.$set(this, 'scrollStyle', style)
          bodyWrapper.addEventListener('scroll', this.onScroll, { passive: true })
          if (ref.$el) {
            const tableWidth = ref.$el.clientWidth
            let bodyMinWidth = 0
            this.tableColRef.forEach((column) => {
              bodyMinWidth += column.width || column.minWidth || 80
            })
            if (bodyMinWidth <= tableWidth) {
              this.isScrollX = false
            } else {
              this.isScrollX = true
            }
          }
          setTimeout(() => {
            this.createdExcelAfter()
          }, 1000);
        })
      }
    },
    getAlign (item) {
      const obj = {
        justifyContent: item && item.textAlign ? item.textAlign : 'left'
      }
      return obj
    },
    getXhWidth () {
      let w = 0
      if (!this.tableDetailData.tableModel || this.tableDetailData.tableModel === 'default') {
        if (this.tableDetailData.raCheckWidth) {
          w = (this.tableDetailData.raCheckWidth < 30 ? 30 : this.tableDetailData.raCheckWidth) + 'px'
        }
      } else {
        if (this.tableDetailData.raCheckWidth) {
          w = Math.ceil(this.tableWidth * this.tableDetailData.raCheckWidth / 100) + 'px'
        }
      }
      return w || '50px'
    },
    onScroll() {
      try {
        const { scrollLeft, scrollWidth, clientWidth } = this.tableRef.bodyWrapper
        const ref = this.$refs.scrollRow
        if (ref) {
          ref.scrollLeft = scrollLeft
          if (clientWidth + scrollLeft === scrollWidth && this.isScrollXbuttom === false) {
            this.isScrollXbuttom = true
          } else if (this.isScrollXbuttom === true) {
            this.isScrollXbuttom = false
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    createdExcelAfter () {
      // 创建成功之后开始渲染表格
      const body = this.tableRef.bodyWrapper.querySelector('.el-table__body')
      let tableWidth = body.clientWidth
      if (this.isAppenTodo) {
        tableWidth -= parseWidth(this.todoWidth)
      }

      if (this.tableDetailData.reCheck) {
        tableWidth -= 50
      }
      const data = this.tableDetailData.titleRowConfig.data
      const html = generateHTMLTableWithWidth(data, {
        tableWidth,
        tableStyleField: { tableWidth: this.tableDetailData.tableModel === 'default' ? 'scroll' : 'fixed' },
        titleStyleConfig: this.tableDetailData.titleConfig,
        colsTotalWidth: this.colsTotalWidth,
        filedWidthList: this.tableDetailData.filedWidthList
      })
      if (this.tableDetailData.tableModel === 'default') {
        const list = generateTableList(data, this.tableDetailData.selectDatas)
        this.$set(this.tableDetailData, 'selectDatas', list)
      }
      const el = this.$refs.excelRow
      if (el) {
        el.innerHTML = html
      }
    },
  }
}
</script>

<style scoped lang="scss">
.custom {
  position: relative;
  overflow: hidden;
  &:hover {
    .row-model {
      display: inline-block;
    }
  }
  .scroll-todo {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  }
  .row-model {
    position: absolute;
    inset: 0;
    background-color: #0000008d;
    display: none;
    .iconbianji {
      color: #fff;
      display: inline-block;
      cursor: pointer;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      &:hover {
        color: #4e86ff;
      }
    }
  }
  .custom-row {
    background-color: rgb(248, 249, 251);
    border: solid 1px #EBEEF5;
    border-bottom: none;
    box-sizing: border-box;
    height: 34px;
    line-height: 34px;
    display: flex;
    position: relative;
    &-item {
      border-right: #EBEEF5 solid 1px;
      box-sizing: border-box;
      user-select: none;
      padding: 0 10px;
      flex-shrink: 0;
      &:last-of-type {
        border-right: none;
      }
    }
    .selection {
      height: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
    }
  }
  .scroll-row {
    display: flex;
    position: relative;
    min-height: 34px;
    height: fit-content;
    width: max-content;
    overflow: hidden;
  }
  .excel-row {
    background-color: rgb(248, 249, 251);
    box-sizing: border-box;
    display: flex;
    position: relative;
    min-height: 34px;
    height: fit-content;
    &-item {
      flex: 1;
    }
    .excel-table {
      td {
        user-select: none;
      }
    }
    .serialNumber {
      display: flex;
      align-items: center;
      border-left: solid 1px #EBEEF5;
      border-top: solid 1px #EBEEF5;
      padding: 0 10px;
      box-sizing: border-box;
      flex-shrink: 0;
    }
    .selection {
      box-sizing: border-box;
      user-select: none;
      padding: 0 10px;
      flex-shrink: 0;
      min-height: 34px;
      border-left: solid 1px #EBEEF5;
      border-top: solid 1px #EBEEF5;
      overflow: hidden;
      display: flex;
      align-items: center;
    }
    .todo {
      box-sizing: border-box;
      user-select: none;
      padding: 0 10px;
      flex-shrink: 0;
      overflow: hidden;
      min-height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: solid 1px #EBEEF5;
      border-top: solid 1px #EBEEF5;
    }
  }
  .fixed-right-patch {
    background-color: #fff;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    position: absolute;
    right: 0;
    top: 0;
    height: -webkit-fill-available;
    width: 6px;
    box-sizing: border-box;
  }
}
</style>
